import React, { useState } from "react";
import { TableHeader } from "@services/ui-components";
import { Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Spinner from "@services/ui-components/src/Spinner/Spinner";
import UpdateRecoveryServiceForm from "./UpdateRecoveryServiceForm";
import { useReactiveVar } from "@apollo/client";
import { ErrorModalComponent } from "@me-pos/error-modal";
import i18next from "i18next";
import { currentCompanyIdVar } from "@me-team/host/main/globalVar/state";
import { CompanyAccess } from "@me-team/host/main/graphql/types";
import { useRoleAccess } from "@me-team/host/src/utils/useRoleAccess";

const RecoveryService: React.FC = () => {
    const { t } = useTranslation();
    const { id, branchId } = useParams();
    const currentCompanyId = useReactiveVar(currentCompanyIdVar);
    const [isErrorModalOpen, setIsErrorModalOpen] = useState<number>(null);
    const canRestoreDeletedService = useRoleAccess(CompanyAccess.ServiceDeleteRestore);

    if (!currentCompanyId) return <Spinner />;

    return (
        <div className="mb-3">
            <TableHeader
                title={t("Restore the Service")}
                paths={[
                    {
                        path: `/services/service/${currentCompanyId}/service-list/${branchId}`,
                        label: t("Service list"),
                    },
                    {
                        path: `/services/service/${currentCompanyId}/service-list/${id}/restore/${branchId}`,
                        label: t("Restore the Service"),
                    },
                ]}
                colSize={12}
            />
            <Row>
                <UpdateRecoveryServiceForm canEditService={canRestoreDeletedService} />
            </Row>
            {isErrorModalOpen ? (
                <ErrorModalComponent
                    i18n={i18next}
                    onClose={() => {
                        setIsErrorModalOpen(null);
                    }}
                    isOpen={!!isErrorModalOpen}
                    currentError={isErrorModalOpen}
                />
            ) : null}
        </div>
    );
};

export default RecoveryService;
